/**
 * Removes all HTML tags from the given string.
 *
 * @param str - The input string that may contain HTML tags.
 * @returns The input string with all HTML tags removed.
 */
export default function stripTags(input: string): string {
  return input
    .replace(/<\/?[a-z][\s\S]*?>/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
}
